<template>
  <div :style="{...styles.base}" :class="getCss(['contract-container'])">
    <div :class="getCss(['contract-content'])" :style="getBgImageStyle"
     v-if="patternTab">
     <div :class="getCss(['contract-content-top'])">
       <!-- <span :class="getCss(['comma-up'])">“</span> -->
       <p :class="getCss(['contract-content-text'])" :style="fontStyle">
        {{ configurationData.agreement }}
       </p>
       <!-- <span :class="getCss(['comma-down'])">”</span> -->
     </div>
     <div :class="getCss(['agree-contract-area',!patternTab ? 'agree-contract-areapc' : ''])"
      :style="configurationData.isCenter ? btnCenter : btnMarginTop"
      v-if="showClickUserContract">
        <label v-if="patternTab"
        :style="configurationData.isCenter ? '' : btnMarginLeft"
               :class="getCss(['user-contract',isCheckUserContract ? 'check-box-input-check' :'' ])">
          <input type="checkbox" v-model="isCheckUserContract" :class="getCss('check-box')">
          <span :class="getCss(['check-box-input'])" :style="butStyls">
          </span>
          <span :class="getCss('read-text')" :style="contractFontStyle">
              我已阅读并同意上述内容
          </span>
        </label>
        <!-- 适配 -->
        <label v-else
        :style="btnMarginLeft"
               :class="getCss(['user-contract',isCheckUserContract ? 'check-box-input-check' :'' ])">
          <input type="checkbox" v-model="isCheckUserContract" :class="getCss('check-box')">
          <span :class="getCss(['check-box-inputs'])" :style="butStyls">
          </span>
          <span :class="getCss('read-texts')" :style="contractFontStyle">
              我已阅读并同意上述内容
          </span>
        </label>
    </div>
    </div>

  </div>

</template>

<script>
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CSupercoreClickUserContract',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 's-super-user-contract-style-',
      isCheckUserContract: false,
      showClickUserContract: true,
    };
  },
  computed: {
    isMobile() {
      return common.platform.isIos || common.platform.isAndroid;
    },
    getBgImageStyle() {
      return {
        backgroundImage: `url(${
          this.configurationData.bgImage || 'http://svipcms-30096.sz.gfp.tencent-cloud.com/73c583b9225b51cf489ad66079742185.png'
        })`,
        '--padding-spacing': this.deviceMode === 'pc' ? '100px 90px 0 90px' : '0.5rem 0.45rem 0rem 0.45rem',
      };
    },
    fontStyle() {
      return {
        color: this.styles.fontStyle.color,
        fontSize: this.styles.fontStyle.fontSize,
      };
    },
    contractFontStyle() {
      return {
        color: this.styles.contractFontStyle.color,
        fontSize: this.styles.contractFontStyle.fontSize,
        '--marginLeft': this.deviceMode === 'pc' ? '20px' : '0.1rem'
      };
    },
    gameName() {
      return this.configurationData.gameName || '游戏名称';
    },
    butStyls() {
      return {
        borderColor: this.configurationData.butBorderColor,
        backgroundColor: this.configurationData.butBgColor,
        '--widthCircle': this.deviceMode === 'pc' ? '45px' : '0.32rem',
        '--heightCircle': this.deviceMode === 'pc' ? '45px' : '0.32rem',
        '--widthYes': this.deviceMode === 'pc' ? '15px' : '0.1rem',
        '--heightYes': this.deviceMode === 'pc' ? '30px' : '0.2rem',
        '--leftYes': this.deviceMode === 'pc' ? '10px' : '0.05rem',
        '--topYes': this.deviceMode === 'pc' ? '20px' : '0.12rem',
      };
    },
    patternTab() { // 模式选择
      return this.configurationData.patternTab;
    },
    btnCenter() {
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      };
    },
    btnMarginTop() {
      return {
        marginTop: `${this.configurationData.buttonMarginTop / 100}rem`,
      };
    },
    btnMarginLeft() {
      return {
        marginLeft: `${this.configurationData.buttonMarginLeft / 100}rem`,
      };
    },
    // 移动端高度处理
    // boxHeightPixel() {
    //   const heightStyle = {
    //     height: this.configurationData?.butomHeight || '0px',
    //   };
    //   if (this.isMobile) {
    //     return common.tool.transformStyle(heightStyle);
    //   }
    //   // pc端不处理
    //   return {
    //     height: `${this.configurationData?.butomHeight}`,
    //   };
    // },
  },
  watch: {
    isCheckUserContract(val) {
      this.$eventBus.$emit('ceiba:custom:events:SyncUserContractStatus', { status: val });
    },
  },
  async mounted() {
    await this.initialize();
  },
  // beforeDestroy() {
  //   // 移除监听事件"aMsg"
  //   this.$EventBus.$off('ceiba:custom:events:CheckUserContractStatus');
  // },
  methods: {
    async initialize() {
      // 监听 同步信息  监听后台同步的数据
      this.$eventBus.$on('ceiba:custom:events:CheckUserContractStatus', ({ status }) => {
        if (status) {
          this.isCheckUserContract = true;
          this.showClickUserContract = false;
        } else  {
          this.isCheckUserContract = false;
          this.showClickUserContract = true;
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import './styles.scss';
</style>
